// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3m-F_","buttons":"Footer_buttons__TIu6D"};